import { ActivitySelectionVersion } from '@shared/enums';

export interface UserPreferences {
  enableFinishTimeAutoPopulationForActivities: boolean;
  activitySelectionVersion: ActivitySelectionVersion;
}
